import ImgCard from './ImgCard';

const ImgCardLoader = ({ className }: any) => {
  return (
    <>
      {/* <Grid container spacing={1}>
        <Grid lg={2} md={3} xs={2}>
          <ImgCard />
        </Grid>
        <Grid lg={2} md={3} xs={2}>
          <ImgCard />
        </Grid>
        <Grid lg={2} md={3} xs={2}>
          <ImgCard />
        </Grid>
        <Grid lg={2} md={3} xs={2}>
          <ImgCard />
        </Grid>
        <Grid lg={2} md={3} xs={2}>
          <ImgCard />
        </Grid>
        <Grid lg={2} md={3} xs={2}>
          <ImgCard />
        </Grid>
        <Grid lg={2} md={3} xs={2}>
          <ImgCard />
        </Grid>
        <Grid lg={2} md={3} xs={2}>
          <ImgCard />
        </Grid>
        <Grid lg={2} md={3} xs={2}>
          <ImgCard />
        </Grid>
      </Grid> */}

      <div className={className ? className : `img-cards-loader-row`}>
        <ImgCard />
        <ImgCard />
        <ImgCard />
        <ImgCard />
        <ImgCard />
        <ImgCard />
        <ImgCard />
        <ImgCard />
        <ImgCard />
      </div>
    </>
  );
};

export default ImgCardLoader;
